import { Stack } from "@mui/material";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { useUpdateNotificationSettingsMutation } from "web_myplann/More/NotificationSettings/Api/useUpdateNotificationSettingsMutation";
import { CONTRACTS_TOGGLE_CONFIG } from "web_myplann/More/NotificationSettings/Components/contractsToggleConfig";
import { NotificationToggleItem } from "web_myplann/More/NotificationSettings/Components/NotificationToggleItem";
import { useContractsSectionDerivation } from "web_myplann/More/NotificationSettings/Hooks/useContractsSectionDerivation";
import { CollapsibleSection } from "web_myplann/Shared/Components/CollapsibleSection";

export const ContractsSection = () => {
	const { t } = useResource();
	const { items, isSectionVisible } = useContractsSectionDerivation();
	const { mutate } = useUpdateNotificationSettingsMutation();

	if (!isSectionVisible) {
		return null;
	}

	return (
		<CollapsibleSection
			title={t(Resources.Settings.NotificationSettings.Sections.Contracts)}
		>
			<Stack sx={{ bgcolor: "background.paper" }}>
				{CONTRACTS_TOGGLE_CONFIG.map((config) => {
					const item = items[config.key];
					return (
						<NotificationToggleItem
							key={config.key}
							label={t(config.labelResource)}
							checked={item.isToggleable && item.isEnabled}
							disabled={!item.isToggleable}
							onChange={(next) => mutate({ key: config.key, value: next })}
						/>
					);
				})}
			</Stack>
		</CollapsibleSection>
	);
};
